import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Row from '../../utils/StyledRow'
import WidgetContainer from '../../containers/WidgetContainer'
import ExchangeRates from './ExchangeRates'
import ExchangeForm from './ExchangeForm'
import ExchangeCol from './StyledExchangeCol'
import ExchangeWrapper from './StyledExchangeWrapper'
import ExchangeImageBox from './StyledExchangeImageBox'
import SimpleTitle from '../../boxes/titles/SimpleTitle'
import LinkHandler from '../../utils/LinkHandler'
import SpirmonWrapper from '../Advert/SpirMonWrapper'
import { FORM_CURRENCIES, FORM_OPERATIONS, EXCHANGE_FORMAT_REGEXP, SIZES, DEVICES } from '../../../constants'

const StyledSimpleTitle = styled(SimpleTitle)`
  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    display: block;
    width: 128px;
  }
`

class Exchange extends Component {
  constructor (props) {
    super(props)

    const {
      widget: {
        boxes,
        meta: {
          articleSource
        }
      }
    } = props

    const exchangeArticleBox = boxes.filter(box => box.source === articleSource)[0]
    const currencies = {}

    boxes
      .filter(exchangeRate => exchangeRate.source === 'Exchange')
      .forEach(({guid: currency, exchangeRate: rate, images}) => {
        currencies[currency] = {
          rate,
          currencyAmount: '1.00',
          czkAmount: `${rate}`,
          icon: images['4_3']
        }
      })

    this.state = {
      currencies,
      exchangeArticleBox,
      exchangeForm: {
        activeCurrency: Object.keys(currencies)[0],
        currencyPicker: FORM_CURRENCIES,
        activeOperation: FORM_OPERATIONS[0].value,
        amount: 1
      }
    }

    this.handleCurrencyChange = this.handleCurrencyChange.bind(this)
  }

  calculateExchangeRate (stringValue, rate, direction) {
    let czkAmount = 0
    let currencyAmount = 0
    const numericValue = parseFloat(stringValue.replace(',', '.'))

    if (direction === FORM_OPERATIONS[0].value) {
      czkAmount = !(stringValue === '' || stringValue === '---') ? rate * numericValue : '---'
      currencyAmount = stringValue
    } else if (direction === FORM_OPERATIONS[1].value) {
      czkAmount = stringValue
      currencyAmount = !(stringValue === '' || stringValue === '---') ? numericValue / rate : '---'
    }

    return {
      currencyAmount,
      czkAmount
    }
  }

  formatExchangeRate ({currencyAmount, czkAmount}, hasComma) {
    return {
      currencyAmount: typeof currencyAmount !== 'string' ? this.floatToString(currencyAmount, hasComma) : currencyAmount,
      czkAmount: typeof czkAmount !== 'string' ? this.floatToString(czkAmount, hasComma) : czkAmount
    }
  }

  floatToString (numericValue, hasComma) {
    let stringValue = numericValue.toFixed(2)

    if (hasComma) {
      stringValue = stringValue.replace('.', ',')
    }

    return stringValue
  }

  handleCurrencyChange (currency, initialValue, direction) {
    const {
      currencies
    } = this.state

    const stringValue = `${initialValue}`

    if (!(new RegExp(EXCHANGE_FORMAT_REGEXP).test(stringValue) || stringValue === '' || stringValue === '---')) {
      return false
    }

    const hasComma = stringValue.indexOf(',') > -1

    const newAmounts = this.calculateExchangeRate(stringValue, currencies[currency].rate, direction)
    const formattedAmounts = this.formatExchangeRate(newAmounts, hasComma)
    const newCurrencies = Object.assign({}, currencies, {
      [currency]: Object.assign({}, currencies[currency], formattedAmounts)
    })

    const exchangeForm = {
      activeCurrency: currency,
      activeOperation: direction,
      amount: formattedAmounts.currencyAmount
    }

    this.setState({
      currencies: newCurrencies,
      exchangeForm
    })
  }

  getRedirectOptions () {
    const {
      widget: {
        meta: {
          admon
        }
      },
      activeDynamicLayout
    } = this.props

    let redirectOptions = Object.assign({}, admon)
    Object.assign(redirectOptions, {
      fcid: admon.fcid[activeDynamicLayout],
      device: activeDynamicLayout === 'desktop' ? 'd' : 'm'
    })
    return redirectOptions
  }

  render () {
    const {
      widget,
      widget: {
        imageSize,
        meta: {
          goIdDeviceList
        }
      },
      activeDynamicLayout
    } = this.props
    const {
      currencies,
      exchangeArticleBox,
      exchangeForm
    } = this.state

    const redirectOptions = this.getRedirectOptions()
    const exchangeArticle = Object.assign({}, exchangeArticleBox, {
      image: `${STATICS_PATH}${exchangeArticleBox.images[imageSize]}`,
      link: new LinkHandler(exchangeArticleBox.link).applySASRedirect(redirectOptions).link
    })
    const goId = activeDynamicLayout === DEVICES.MOBILE ? goIdDeviceList.mobile : goIdDeviceList.desktop

    return (
      <WidgetContainer widget={widget}>
        <Row>
          <ExchangeCol>
            <ExchangeWrapper>
              <ExchangeRates currencies={currencies} handleCurrencyChange={this.handleCurrencyChange}/>
              <ExchangeForm exchangeForm={exchangeForm} goId={goId} redirectOptions={redirectOptions}/>
            </ExchangeWrapper>
            <ExchangeImageBox box={exchangeArticle} className='vertical' imageClass={imageSize}>
              <StyledSimpleTitle box={exchangeArticle}/>
            </ExchangeImageBox>
          </ExchangeCol>
        </Row>
      </WidgetContainer>
    )
  }
}

Exchange.propTypes = {
  widget: PropTypes.object.isRequired,
  activeDynamicLayout: PropTypes.string.isRequired
}

export default SpirmonWrapper(Exchange)
